<template>
  <div
    ref="dropdownParent"
    class="flex tb-button-group !border-l-0 dropdown-menu-section"
  >
    <v-popover
      interactive
      tag="div"
      content-tag="div"
      placement="bottom-start"
      class="p-0"
      :trigger="'click'"
      :role="'poper'"
    >
      <template #default>
        <button
          ref="dropdownButton"
          :class="{ 'disabled-toolbar-option': command?.disabled() }"
          @keydown.stop.prevent="handleKeyDown"
        >
          <em
            class="custom-icons"
            :style="getCustomIconStyle(icon)"
          >
          </em>
        </button>
      </template>
      <template #content="{ state }">
        <div
          v-if="state.isVisible"
          ref="dropdownContent"
          class="flex items-center justify-center p-0.5 rounded-[4px] border border-solid border-important-border shadow-md bg-important-bg"
        >
          <MenuSection
            :editor="props.editor"
            :commands="props.dropdownCommands"
          />
        </div>
      </template>
    </v-popover>
  </div>
</template>

<script setup lang="ts">
import { Editor } from '@tiptap/core';
import { ref, getCurrentInstance, computed } from 'vue';
import type { MenuItemFn } from '@/components/editor/toolbar/menu-item';
import useCustomIcon from '@/utilities/composables/useCustomIcon';
import MenuSection from '@/components/editor/toolbar/MenuSection.vue';
import useTranslate from '@/utilities/composables/useTranslate';

const props = defineProps<{
  command: MenuItemFn;
  dropdownCommands?: MenuItemFn;
  editor: Editor;
}>();

const { iconPath, getCustomIconStyle } = useCustomIcon();
const { translate } = useTranslate();
const _this = getCurrentInstance();

const dropdownParent = ref();
const dropdownButton = ref();

const handleKeyDown = (event: KeyboardEvent) => {
  isTextAlignShortcut(event);
};

const preventAndStop = (event: Event) => {
  event.preventDefault();
  event.stopPropagation();
};

const isTextAlignShortcut = (event: KeyboardEvent) => {
  const key = event.key;
  const textAlignMap: { [key: string]: string } = {
    r: 'right',
    l: 'left',
    c: 'center',
  };

  // Check if Ctrl or Command and Shift keys are pressed
  if (!(event.ctrlKey || event.metaKey) || !event.shiftKey || !textAlignMap[key]) {
    return;
  }

  preventAndStop(event);
  props.editor.chain().focus().setTextAlign(textAlignMap[key]).run();
};

const command = computed(() =>
  props.command({
    editor: props.editor,
    translate,
    store: (_this?.proxy as any).$store!,
  })
);

const icon = computed(() => iconPath(command.value.icon()));
</script>
